import type { RJSFInputProps } from '@/components/organisms/DynamicForm/components/RSJVInputAdaters/types';

import type { TextInputFieldType } from '../types';

export const detectFieldType = (fieldProps: RJSFInputProps<unknown>): TextInputFieldType => {
  if (fieldProps.schema.oneOf || fieldProps.schema.enum) return 'select';

  return 'text';
};
